import { render, staticRenderFns } from "./Banner-Component.vue?vue&type=template&id=2308ad2b&scoped=true&"
import script from "./Banner-Component.vue?vue&type=script&lang=js&"
export * from "./Banner-Component.vue?vue&type=script&lang=js&"
import style0 from "./Banner-Component.vue?vue&type=style&index=0&id=2308ad2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2308ad2b",
  null
  
)

export default component.exports